"use strict";

exports.__esModule = true;
exports.BindDataToComponents = void 0;
var _dataset = require("../entities/dataset");
const BindDataToComponents = ({
  dataStore,
  renderNextRecord,
  renderPrevRecord
}) => async ({
  dataset,
  connections,
  components
}) => {
  const datasetData = dataset.get();
  await dataStore.getSchema(datasetData.collectionId);
  const records = await dataStore.getRecords(datasetData.collectionId, {
    offset: 0,
    limit: 1
  });
  dataset.set(_dataset.Dataset.updateListing, {
    records
  });
  if (connections.length) {
    for (const connection of connections) {
      const boundBehaviors = mapBehaviorsToComponent({
        dataset,
        connection,
        api: {
          renderNextRecord,
          renderPrevRecord
        }
      });
      const component = components.find(comp => comp.id === connection.compId);
      component.bind(boundBehaviors);
    }
  }
};
exports.BindDataToComponents = BindDataToComponents;
const mapBehaviorsToComponent = ({
  dataset,
  connection,
  api
}) => {
  let behaviorDescriptors = {};
  const {
    behaviors,
    properties
  } = connection;
  for (const [name, connectionDescriptor] of Object.entries(properties)) {
    if (connectionDescriptor.behaviors) {
      behaviorDescriptors[name] = mapBehaviorsToComponent({
        dataset,
        connection: connectionDescriptor,
        api
      });
    }
  }
  for (const [behaviorName, behavior] of Object.entries(behaviors)) {
    behaviorDescriptors = {
      ...behaviorDescriptors,
      ...behaviorBinders[behaviorName]({
        dataset,
        properties,
        behavior,
        api
      })
    };
  }
  return behaviorDescriptors;
};
const behaviorBinders = {
  input: ({
    dataset,
    properties,
    behavior: {
      onChange: onChangeProp,
      value: valueProp
    }
  }) => ({
    [onChangeProp]: value => dataset.set(_dataset.Dataset.updateCurrentRecord, {
      [properties[valueProp].fieldName]: value
    })
  }),
  click: settings => actionHandlers[settings.behavior.action](settings)
};
const actionHandlers = {
  next: ({
    behavior: {
      onClick: onClickProp
    },
    api: {
      renderNextRecord
    }
  }) => ({
    [onClickProp]: () => renderNextRecord()
  }),
  previous: ({
    behavior: {
      onClick: onClickProp
    },
    api: {
      renderPrevRecord
    }
  }) => ({
    [onClickProp]: () => renderPrevRecord()
  })
};
//# sourceMappingURL=bind-data-to-components.js.map